<template>
  <div class="topnav">
    <div class="container-fluid">
      <nav class="navbar navbar-light navbar-expand-lg topnav-menu active">
        <div class="collapse navbar-collapse active" id="topnav-menu-content">
          <ul class="navbar-nav" v-if="role == 'admn'">
            <!-- Menu data -->

            <li
              class="nav-item dropdown"
              v-for="(item, index) of menuItems"
              :key="index"
            >
              <a
                class=""
                target="_blank"
                v-if="item.id == 30"
                :href="item.link"
                id="topnav-components"
                role="button"
              >
                <a :to="item.link" class="nav-link dropdown-toggle arrow-none">
                  <i :class="`bx ${item.icon} mr-2`"></i>
                  {{ $t(item.label) }}
                </a>
                <!-- <div class="arrow-down"></div> -->
              </a>
              <a
                class=""
                v-else
                @click="onMenuClick"
                :href="item.link"
                id="topnav-components"
                role="button"
              >
                <router-link
                  :to="item.link"
                  class="nav-link dropdown-toggle arrow-none"
                >
                  <i :class="`bx ${item.icon} mr-2`"></i>
                  {{ $t(item.label) }}
                </router-link>
                <!-- <div class="arrow-down"></div> -->
              </a>
              <div
                class="dropdown-menu row"
                aria-labelledby="topnav-dashboard"
                v-if="hasItems(item)"
              >
                <span v-for="(subitem, index) of item.subItems" :key="index">
                  <router-link
                    class="col dropdown-item side-nav-link-ref"
                    v-if="!hasItems(subitem)"
                    :to="subitem.link"
                    >{{ $t(subitem.label) }}</router-link
                  >
                  <div class="dropdown" v-if="hasItems(subitem)">
                    <a
                      class="dropdown-item"
                      :href="item.link"
                      @click="onMenuClick"
                    >
                      {{ $t(subitem.label) }}
                      <div class="arrow-down"></div>
                    </a>
                    <div class="dropdown-menu">
                      <router-link
                        v-for="(subSubitem, index) of subitem.subItems"
                        :key="index"
                        :to="subSubitem.link"
                        class="dropdown-item side-nav-link-ref"
                        >{{ $t(subSubitem.label) }}</router-link
                      >
                    </div>
                  </div>
                </span>
              </div>
            </li>
          </ul>
          <ul class="navbar-nav" v-else-if="role == 'anly'">
            <!-- Menu data -->

            <li
              class="nav-item dropdown"
              v-for="(item, index) of menuItemsAnly"
              :key="index"
            >
              <a
                class=""
                @click="onMenuClick"
                :href="item.link"
                id="topnav-components"
                role="button"
              >
                <router-link
                  :to="item.link"
                  class="nav-link dropdown-toggle arrow-none"
                >
                  <i :class="`bx ${item.icon} mr-2`"></i>
                  {{ $t(item.label) }}
                </router-link>
                <!-- <div class="arrow-down"></div> -->
              </a>
              <div
                class="dropdown-menu row"
                aria-labelledby="topnav-dashboard"
                v-if="hasItems(item)"
              >
                <span v-for="(subitem, index) of item.subItems" :key="index">
                  <router-link
                    class="col dropdown-item side-nav-link-ref"
                    v-if="!hasItems(subitem)"
                    :to="subitem.link"
                    >{{ $t(subitem.label) }}</router-link
                  >
                  <div class="dropdown" v-if="hasItems(subitem)">
                    <a
                      class="dropdown-item"
                      :href="item.link"
                      @click="onMenuClick"
                    >
                      {{ $t(subitem.label) }}
                      <div class="arrow-down"></div>
                    </a>
                    <div class="dropdown-menu">
                      <router-link
                        v-for="(subSubitem, index) of subitem.subItems"
                        :key="index"
                        :to="subSubitem.link"
                        class="dropdown-item side-nav-link-ref"
                        >{{ $t(subSubitem.label) }}</router-link
                      >
                    </div>
                  </div>
                </span>
              </div>
            </li>
          </ul>
          <ul class="navbar-nav" v-else-if="role == 'verf'">
            <!-- Menu data -->
            <li
              class="nav-item activedropdown"
              v-for="(item, index) of menuItemsAnly"
              :key="index"
            >
              <a
                class=""
                @click="onMenuClick"
                :href="item.link"
                id="topnav-components"
                role="button"
              >
                <router-link
                  :to="item.link"
                  class="nav-link dropdown-toggle arrow-none"
                >
                  <i :class="`bx ${item.icon} mr-2`"></i>
                  {{ $t(item.label) }}
                </router-link>
                <!-- <div class="arrow-down"></div> -->
              </a>
              <div
                class="dropdown-menu row"
                aria-labelledby="topnav-dashboard"
                v-if="hasItems(item)"
              >
                <span v-for="(subitem, index) of item.subItems" :key="index">
                  <router-link
                    class="col dropdown-item side-nav-link-ref"
                    v-if="!hasItems(subitem)"
                    :to="subitem.link"
                    >{{ $t(subitem.label) }}</router-link
                  >
                  <div class="dropdown" v-if="hasItems(subitem)">
                    <a
                      class="dropdown-item"
                      :href="item.link"
                      @click="onMenuClick"
                    >
                      {{ $t(subitem.label) }}
                      <div class="arrow-down"></div>
                    </a>
                    <div class="dropdown-menu">
                      <router-link
                        v-for="(subSubitem, index) of subitem.subItems"
                        :key="index"
                        :to="subSubitem.link"
                        class="dropdown-item side-nav-link-ref"
                        >{{ $t(subSubitem.label) }}</router-link
                      >
                    </div>
                  </div>
                </span>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import { layoutMethods } from "@/state/helpers";
import { menuItems } from "./horizontal-menu";
import { menuItemsVerf } from "./horizontal-menu-verf";
import { menuItemsAnly } from "./horizontal-menu-anly";

export default {
  data() {
    return {
      role: this.$store.state.authBackend.role,
      menuItems: menuItems,
      menuItemsVerf: menuItemsVerf,
      menuItemsAnly: menuItemsAnly,
    };
  },
  mounted() {
    var links = document.getElementsByClassName("side-nav-link-ref");
    var linksnav = document
      .getElementsByClassName("navbar-nav")[0]
      .getElementsByTagName("li");
    var matchingMenuItem = null;
    for (var i = 0; i < linksnav.length; i++) {
      let currPage = window.location.pathname;
      let relLink = this.menuItems[i].relatedlink ?? [];
      if (
        currPage ===
          linksnav[i].getElementsByTagName("a")[0].getAttribute("href") ||
        relLink.includes(currPage)
      ) {
        matchingMenuItem = linksnav[i].getElementsByTagName("a")[1];
        break;
      }
    }

    // for (var i = 0; i < links.length; i++) {
    //   if (window.location.pathname === links[i].pathname) {
    //     matchingMenuItem = links[i];
    //     break;
    //   }
    // }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      var parent = matchingMenuItem.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add("active");
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.add("active");
        }
        const parent3 = parent2.parentElement;
        if (parent3) {
          parent3.classList.add("active");
          var childAnchor = parent3.querySelector(".has-dropdown");
          if (childAnchor) childAnchor.classList.add("active");
        }

        const parent4 = parent3.parentElement;
        if (parent4) parent4.classList.add("active");
        const parent5 = parent4.parentElement;
        if (parent5) parent5.classList.add("active");
      }
    }
  },
  methods: {
    ...layoutMethods,
    /**
     * Menu clicked show the submenu
     */
    onMenuClick(event) {
      event.preventDefault();
      const nextEl = event.target.nextSibling;
      if (nextEl && !nextEl.classList.contains("show")) {
        const parentEl = event.target.parentNode;
        if (parentEl) {
          parentEl.classList.remove("show");
        }
        nextEl.classList.add("show");
      } else if (nextEl) {
        nextEl.classList.remove("show");
      }
      return false;
    },
    change_layout(layout) {
      return this.changeLayoutType({ layoutType: layout });
    },
    topbarLight() {
      document.body.setAttribute("data-topbar", "light");
      document.body.removeAttribute("data-layout-size", "boxed");
    },
    boxedWidth() {
      document.body.setAttribute("data-layout-size", "boxed");
      document.body.removeAttribute("data-topbar", "light");
      document.body.setAttribute("data-topbar", "dark");
    },
    coloredHeader() {
      document.body.setAttribute("data-topbar", "colored");
      document.body.removeAttribute("data-layout-size", "boxed");
    },
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },
  },
};
</script>
